/**
 * Stripe Managed Payments eligibility constants for CourtSync platform subscriptions.
 * @see https://docs.stripe.com/payments/managed-payments/eligibility
 */

/** ISO 3166-1 alpha-2 country codes where Managed Payments buyers are restricted. */
export const MANAGED_PAYMENTS_RESTRICTED_COUNTRIES = [
  'AC', // Ascension Island
  'CN', // China
  'CU', // Cuba
  'IR', // Iran
  'XK', // Kosovo
  'KP', // North Korea
  'RU', // Russia
  'SY', // Syria
  'TA', // Tristan da Cunha
] as const;

export type ManagedPaymentsRestrictedCountry =
  (typeof MANAGED_PAYMENTS_RESTRICTED_COUNTRIES)[number];

/** Stripe tax code: Software as a service (SaaS) - business use */
export const MANAGED_PAYMENTS_TAX_CODE_SAAS_BUSINESS = 'txcd_10103001';

/**
 * Platform subscription list prices include GST/VAT/sales tax.
 * Managed Payments extracts tax from this amount instead of adding it at checkout.
 * @see https://docs.stripe.com/payments/managed-payments/set-up#configure-tax-behavior
 */
export const MANAGED_PAYMENTS_TAX_BEHAVIOR = 'inclusive' as const;
